import {
  SfMediaImage, SfSection, SfBanner
} from '@app/sf-lib/public_api';
import { SomPage } from './page.model';

export class SomFieldToPlatePage extends SomPage implements SfBanner {

  public nid: number;

  /** Type from server */
  public type: string;

  /** Title */
  public title: string;

  /** Path alias information */
  public path: {
    alias: string;
  };

  /** Main image of the article */
  public cover: SfMediaImage;

  /** Main image of the article for mobile */
  public smallcover: SfMediaImage;

  public sections: SfSection[];

  /** SfBanner uppertitle */
  public uppertitle: string;

  /** SfBanner background */
  public get background(): SfMediaImage {
    return this.cover;
  }

  /** SfBanner smallbackground */
  public get smallbackground(): SfMediaImage {
    return this.smallcover;
  }

  /**
   * Custom function used by JSON.stringify
   *
   * @param {string} nm Name of the property
   * @returns {string}
   * @memberof SomFieldToPlatePage
   */
  public toJSON(nm: string) {
    const newArticle = {
      nid: this.nid,
      type: this.type,
      title: this.title,
      path: this.path,
      cover: this.cover,
      sections: this.sections,
      uppertitle: this.uppertitle,
      background: this.background,

      lang: this.lang,
      content: this.content,
      meta_title: this.meta_title,
      meta_description: this.meta_description,
      meta_keywords: this.meta_keywords,
    };
    return newArticle;
  }
}
